import { create } from 'zustand';

export interface UserStoreState {
  cars: any[];
  loading: boolean;
}

interface UserPhoneStoreActions {
  setUserCars: (user: UserStoreState) => void;
  setLoading: (state: boolean) => void;
}

interface UserStore {
  state: UserStoreState;
  actions: UserPhoneStoreActions;
}

export const useUserCarsStore = create<UserStore>((set) => ({
  state: {
    cars: [],
    loading: false,
  },
  actions: {
    setUserCars: (cars) => set({ state: cars }),
    setLoading: (load) =>
      set((state) => {
        return { state: { ...state.state, load } };
      }),
  },
}));
